import type { ReactNode, RefObject } from 'react';
import { forwardRef } from 'react';

import type { ListProps, ListState } from '@react-stately/list';

import { useListBox } from '@react-aria/listbox';

import { Option } from '../Option';

type Props = ListProps<object> & {
  state: ListState<object>;
  close?: () => void;
  emptyStateRender?: (props: { close?: () => void }) => ReactNode;
};

export const ListBox = forwardRef<HTMLUListElement, Props>((props, ref) => {
  const { state, close, emptyStateRender } = props;
  const { collection } = state;

  const { listBoxProps } = useListBox(
    props,
    state,
    ref as RefObject<HTMLUListElement>
  );

  return (
    <ul
      {...listBoxProps}
      ref={ref}
      className="mx-0 my-2 max-h-[250px] min-w-[200px] list-none overflow-auto 
    rounded-x0_5 bg-p-white px-0 py-2"
    >
      {collection.size === 0 && emptyStateRender?.({ close })}
      {[...collection].map((item) => (
        <Option key={item.key} item={item} state={state} />
      ))}
    </ul>
  );
});

ListBox.displayName = 'ListBox';
